<template>
  <div>
    <!--常用模块-->
    <div class="d-model">
      <router-link to="/log">平台文档</router-link>
    </div>
    <!-- 名片 -->
    <div class="d-model">
      <div>↓↓↓↓ 钉钉群 ↓↓↓↓</div>
      <img :src="ding" alt="" style="width: 400px" />
    </div>
  </div>
</template>

<script>
import ding from '@/assets/ding.jpg'
export default {
  name: 'homePage',
  data() {
    return {
      ding,
    }
  },
}
</script>

<style scoped>
.d-model {
  text-align: center;
  padding: 15px;
  font-size: 20px;
}
</style>
